import GoogleAnalyticsEvent from 'dataTransferObjects/googleAnalyticsEvent';
import GoogleAnalyticsEventAction from 'enums/googleAnalyticsEventAction';
import GoogleAnalyticsEventCategory from 'enums/googleAnalyticsEventCategory';

/* Creates a new instance of a Google Analytics Tdv Events Mixin to track user's events when the user submits a lead. */
export default class EventTrackingNonDirectLeadsMixin {
  constructor(model) {
    Object.assign(this, model);
  }

  getGoogleAnalyticsData() {
    return new GoogleAnalyticsEvent(
      GoogleAnalyticsEventCategory.TdvEvents.toString(),
      GoogleAnalyticsEventAction.NonDirectLeads.toString(),
      this.eventLabel
    );
  }
}
